import { AdvertisementInfo } from '../../types/advertisement';
import { getAdvertisement, updateAdvertisementBrowsingFlag } from '../advertisementEndpoint';

export const getAdvertisementService = async () => {
    let adsInfo: AdvertisementInfo[] = [];
    const res = await getAdvertisement();
    if (res.data.detail != null) {
        adsInfo = res.data.detail;
    }
    return adsInfo;
};

export const updateAdvertisementBrowsingFlagService = async (tGadContractId: number, dispCnt: number) => {
    await updateAdvertisementBrowsingFlag(tGadContractId, dispCnt);
};